import { fetchUserCheck, fetchUserSettings, postCookieLogin, postCookieLogout, } from '../apis/api-users.js';
import { userSettings$, user$ } from '../stores/store-user.js';
import { USER_ROLE } from './helper-users.js';
import { setOidcUserStatus } from './oidcUser.js';
export async function cookieLogin(username, password) {
    try {
        const userData = await postCookieLogin(username, password);
        if (userData.loginErrorCode === 200) {
            const data = await fetchUserCheck();
            userData.userid = data.userid;
            user$.next(userData);
            const userSettings = await fetchUserSettings();
            userSettings$.next(userSettings);
            return true;
        }
        return false;
    }
    catch {
        return false;
    }
}
export async function cookieLoginWithErrors(username, password) {
    const userData = await postCookieLogin(username, password);
    if (userData.loginErrorCode === 200) {
        const data = await fetchUserCheck();
        userData.userid = data.userid;
        user$.next({
            userid: userData.userid,
            email: userData.email,
            firstName: userData.firstName,
        });
        const userSettings = await fetchUserSettings();
        userSettings$.next(userSettings);
    }
    return userData;
}
export async function cookieLogout() {
    await postCookieLogout();
    user$.next(null);
    userSettings$.next(null);
}
export async function initializeUserWithCookie() {
    const data = await fetchUserCheck();
    if (data.loggedin) {
        user$.next({
            userid: data.userid,
            email: data.email,
            firstName: data.firstName,
        });
        setOidcUserStatus({
            email: data.email,
            roles: [USER_ROLE.subscribedUser],
        });
        const userSettings = await fetchUserSettings();
        userSettings$.next(userSettings);
        return true;
    }
    return false;
}
//# sourceMappingURL=cookieUser.js.map